import { render, staticRenderFns } from "./TransactionsDetail.vue?vue&type=template&id=258e7b00"
import script from "./TransactionsDetail.vue?vue&type=script&lang=js"
export * from "./TransactionsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports